import dom from '../../utils/dom';

const { formButtonHandler } = window.tnew.handlers;


/**
 * @param {HTMLFormElement} $form
 */
const disableFormControls = ($form) => {
  const $els = [...$form.elements].filter(el => !el.disabled);

  $els.forEach($el => dom.disable($el));

  return {
    reenableControls: () => {
      $els.forEach($el => dom.enable($el));
    },
  };
};


/**
 * @param {HTMLFormElement} $form
 */
const disableForm = ($form) => {
  const $activeEl = document.activeElement;
  const { reenableControls } = disableFormControls($form);

  return {
    reenableForm: () => {
      reenableControls();
      formButtonHandler.resetButtonStyling();
      $activeEl.focus();
    },
  };
};


export default disableForm;



// WEBPACK FOOTER //
// ./src/utils/form/disableForm.js